angular.module('impactx.basket').controller('BasketTemplateListCtrl', [
    'selectedListItems',
    'basketTemplateMenu',
    '$redirect',
    '$context',
    'dataGen',
    BasketTemplateListController]);

function BasketTemplateListController(selectedListItems, basketTemplateMenu, $redirect, $context, dataGen) {
    var self = this;

    self.getDetailLink = function () {
        return "basket/" + selectedListItems.getFirstSelectedId();
    };

    self.addToCurrentBasket = function () {
        basketTemplateMenu.addTemplateToBasket(selectedListItems.getFirstSelectedId()).then(function () {
            $redirect.redirectTo(null, "/basket");
        });
    };

    this.createBasketTemplate = function()
    {
        dataGen.post({}, {}, "/basket/create/template", function (data)
        {
            $context.refreshBasket({}, dataGen, $context);
            $redirect.redirectTo(null,"/basket");
        });
    };

    var buttonDefinition = [
        {label: "details", linkFunction: self.getDetailLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'ViewBasket'},
        {label: "addToBasket", action: self.addToCurrentBasket, condition:  selectedListItems.isSingleSelection, process: 'AddTemplateToBasket'},
    ];

    self.meta = {
        rowTemplate: 'modules/basket/templates/templatelist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/basket/template/list',
        id: 'baskettemplatelist',
        mainActionFunction: {id:"new", action: this.createBasketTemplate, icon:"mdi-plus"},
        buttonDefinition: buttonDefinition
    };

    self.getMeta = function () {
        return self.meta;
    };
}